import axios from "axios";
import { Map, Popup } from "mapbox-gl";
import React, { useContext, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { showErrorMessage } from "../../../helper/helper";
import { UpdatePriceMap } from "../../../helper/mapDataFeed";
import { updatePopup } from "../../../models/MapBoxDataModel";
import { MarketContext, PriceForOrganisation } from "../MyPrices";

type Props = {
    map: Map
    prices: PriceForOrganisation[]
    updateData: number | undefined
}

export type PublicPriceOnMap = {
    id: number,
    price_per_unit: number,
    plot_id?: number,
    price_type: string,
    organisation_id: number,
    organisation_name: string,
    organisation_type: string,
    group_id: number,
    location_village: string,
    location_subdistrict: string,
    position: string,
    program_name: string,
    program_price_per_unit: number,
    market_date: string,
    publisher_id: number,
    location_id: number,
    group_price_per_unit: number,
    publisher_firstname: string,
    publisher_lastname: string,
    organisation_avatar: string,
    start_at: string,
    end_at: string,
    price_count: number,
    bid_warning_message: string,
    standard_grading_ratio: number,
    unloading_fee_pre_applied: boolean,
    price: string,
    icon: string,
    textColor: string,
    sortOrder: number
    qbp_prices?: any
    coordinates?: any
}

export function MapMillPrice({ map, prices, updateData }: Props) {

    const popup = useRef<Popup | undefined>(undefined)

    const priceSelected = useContext(MarketContext)

    const publicPrices = useRef<any>(undefined)

    const token = useSelector((state: any) => state.token.value)


    useEffect(() => {
        refetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updateData])

    function getMatchedObjects(geoJsonData: any, prices: any[]): any[] {
        const matchedObjects: any[] = [];

        if (!geoJsonData || !geoJsonData.features) {
            return matchedObjects; // Return empty array if geoJsonData is invalid
        }

        prices.forEach((price: any) => {
            const priceOrgId = price.org.id;

            const p = geoJsonData.features.find(f => f.properties.organisation_id === priceOrgId)
            if (p) {
                const matchedObject = {
                    ...p,
                    ...price
                };
                matchedObjects.push(matchedObject);
            }
        })
        return matchedObjects;
    }

    async function refetchData() {
        try {
            const mapBoxCall = await axios.get(`${process.env.REACT_APP_BASE_URL_PUBLIC}/mapTilingService/priceTileJsonV2?token=${token}`, {
                withCredentials: false,
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            var url: string = mapBoxCall.data.tiles?.at(0)
            if (url) {
                url = url.replace("{z}/{x}/{y}", "0/0/0")
                console.log('modified string', url)
                const dataCall = await axios.get(url, {
                    withCredentials: false,
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    }
                })
                publicPrices.current = dataCall.data?.at(0).geoJson
                const matches = getMatchedObjects(dataCall.data?.at(0).geoJson, prices)
                if (matches.length === 1) {
                    priceSelected.setPriceSelected({ ...matches[0].properties, coordinates: matches[0].geometry.coordinates })
                } else {
                    updateMap()
                }
            }
        } catch (error) {
            showErrorMessage(error)
        }
    }

    const isMyMill = (id: number) => {
        const price = prices?.find(p => p.org.id === id)
        return price && price.bids?.length > 0
    }

    useEffect(() => {
        updateMap()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [priceSelected.priceSelected])

    function updateMap() {
        UpdatePriceMap(map, publicPrices.current, isMyMill, priceSelected.priceSelected,
            (f: any, geometry: any) => {
                const price = publicPrices.current?.features?.find(g => g.properties.id === f.id)
                if (price.properties.organisation_id === priceSelected?.priceSelected?.organisation_id) {
                    priceSelected.setPriceSelected(undefined)

                } else {
                    priceSelected.setPriceSelected({ ...price.properties, coordinates: geometry.coordinates })
                }
            },
            (f: any, geometry: any) => {
                updatePopup(map, publicPrices.current?.features?.find(p => p.properties.id === f.properties.id), priceSelected.priceSelected, popup)
            }, () => {
                popup.current?.remove()
            }
        )
    }


    // useEffect(() => {
    //     const changeLanguageHandler = (l) => {
    //         if (map) {
    //             updatePopup(map, prices, popups.current)
    //         }
    //     };

    //     i18n.on('languageChanged', changeLanguageHandler);

    //     return () => {
    //         i18n.off('languageChanged', changeLanguageHandler);
    //     };
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [i18n])

    // const getOrgForId = (id: number): Organisation => {
    //     return prices.find(p => p.org.id === id).org
    // }

    return (
        <>

        </>
    )
}